export default "__VITE_ASSET__e86d7d1e__"